// pages/pricing.jsx
export const runtime = 'experimental-edge';
import React from 'react';
import BaseLayout from '../layouts/BaseLayout.jsx';
import PricingTable from '../components/PricingTable';
import { getServerSideAuth } from '../utils/serverSideAuth';

export async function getServerSideProps(context) {
  // Получаем состояние аутентификации с сервера
  const authState = await getServerSideAuth(context);
  
  // Если пользователь аутентифицирован, получаем информацию о подписке
  let subscriptionData = null;
  
  if (authState.isAuthenticated && authState.user) {
    try {
      const backendUrl = process.env.NEXT_PUBLIC_BACKEND_URL;
      
      // Получаем данные о подписке с сервера используя JWT токен
      const response = await fetch(`${backendUrl}/subscription/status`, {
        headers: {
          'Authorization': `Bearer ${context.req.cookies.jwt_access_token || ''}`,
          'Content-Type': 'application/json'
        }
      });
      
      if (response.ok) {
        subscriptionData = await response.json();
      }
    } catch (error) {
      console.error('Ошибка при получении данных о подписке:', error);
    }
  }

  return {
    props: {
      serverAuth: authState,
      initialSubscription: subscriptionData
    }
  };
}

const PricingPage = ({ serverAuth, initialSubscription }) => {
  return (
    <BaseLayout
      title="Pricing"
      description="Our pricing plans and options"
      showHeader={true}
    >
      <div className="page-container-with-top-margin w-full">
        <div className="w-full">
          <h1 className="text-3xl md:text-4xl font-bold text-center mb-4 md:mb-6">Simple, Transparent Pricing</h1>
          <p className="text-lg md:text-xl text-center text-gray-700 mb-6 md:mb-8 max-w-[800px] mx-auto">
            Choose the plan that best fits your needs. All plans include our core features, 
            with additional capabilities available in higher tiers.
          </p>
          
          {/* Передаем начальные данные с сервера в компонент PricingTable */}
          <PricingTable 
            initialSubscriptionData={initialSubscription}
            initialAuth={serverAuth}
          />
          
          <div className="px-4 sm:px-0 max-w-[800px] mx-auto mt-8 md:mt-10">
            <h2 className="text-xl md:text-2xl font-bold mb-3 md:mb-4">Frequently Asked Questions</h2>
            
            <div className="space-y-4 md:space-y-5">
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-1 md:mb-2">Can I change plans later?</h3>
                <p className="text-gray-700 text-sm md:text-base">
                  Yes, you can upgrade or downgrade your plan at any time. Changes to your subscription will take effect on your next billing cycle.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-1 md:mb-2">Is there a contract or commitment?</h3>
                <p className="text-gray-700 text-sm md:text-base">
                  No long-term contracts required. You can pay monthly or annually (with a discount), and cancel anytime.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-1 md:mb-2">Do you offer discounts for non-profits or educational institutions?</h3>
                <p className="text-gray-700 text-sm md:text-base">
                  Yes, we offer special pricing for qualified non-profit organizations and educational institutions. Please contact our sales team for more information.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-1 md:mb-2">How does billing work?</h3>
                <p className="text-gray-700 text-sm md:text-base">
                  We use secure payment processing through Stripe. You'll be billed automatically at the start of each billing cycle. For annual plans, you'll be billed once per year.
                </p>
              </div>
              
              <div>
                <h3 className="text-lg md:text-xl font-semibold mb-1 md:mb-2">What payment methods do you accept?</h3>
                <p className="text-gray-700 text-sm md:text-base">
                  We accept all major credit cards, including Visa, Mastercard, American Express, and Discover. For Enterprise plans, we can also arrange alternative payment methods.
                </p>
              </div>
            </div>
            
            <div className="mt-8 md:mt-10 text-center">
              <h3 className="text-lg md:text-xl font-semibold mb-2 md:mb-3">Need help choosing the right plan?</h3>
              <p className="text-gray-700 text-sm md:text-base mb-4 md:mb-5">
                Our team is ready to help you find the perfect solution for your needs.
              </p>
              <button className="bg-purple-600 text-white px-6 py-2 rounded-full text-sm md:text-base font-medium hover:bg-purple-700 transition-colors">
                Contact Sales
              </button>
            </div>
          </div>
        </div>
      </div>
    </BaseLayout>
  );
};

export default PricingPage;